<template>
  <el-dialog :title="$t('VideoPreview.historyVideo')" :visible.sync="dialogVisible" width="80%"
    :close-on-click-modal="false" @close="handleClose" custom-class="history-video-custom" class="tableDialong">
    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :inline="true" size="small">
        <el-form-item :label="$t('common.choseTime')">
          <el-date-picker v-model="searchForm.dateRange" type="date" :placeholder="$t('common.choseTime')"
            value-format="yyyy-MM-dd" style="width: 150px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch">{{ $t('common.btn.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 摄像头类型标签页 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('VideoPreview.dmsCamera')" name="1"></el-tab-pane>
      <el-tab-pane :label="$t('VideoPreview.frontCamera')" name="2"></el-tab-pane>
      <el-tab-pane :label="$t('VideoPreview.backCamera')" name="3"></el-tab-pane>
      <el-tab-pane :label="$t('VideoPreview.leftCamera')" name="4"></el-tab-pane>
      <el-tab-pane :label="$t('VideoPreview.rightCamera')" name="5"></el-tab-pane>
    </el-tabs>

    <!-- 视频列表表格 -->
    <div class="zMsgTable">
      <i-table :list="videoList" :height="tableHeight" ref="videoTable" :options="tableOptions" :columns="tableColumns"
        :operates="tableOperates"></i-table>
    </div>

    <!-- 分页 -->
    <!-- <IPagination ref="page" @PageFun="changeSize"></IPagination> -->

    <!-- 视频播放弹框 -->
    <el-dialog
      :title="$t('VideoPreview.playHistoryVideo')"
      :visible.sync="playDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      append-to-body
      @close="handlePlayDialogClose"
      class="playVideoDialog"
    >
      <div class="video-player-container">
        <div id="history-video-player-container" class="video-player-inner">
          <div v-if="isLoading" class="loading-overlay">
            <i class="el-icon-loading"></i>
            <span>{{ $t('common.loading') }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="playDialogVisible = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import moment from "moment";

export default {
  name: 'HistoryVideoDialog',
  components: {
    iTable,
    IPagination
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentCarInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      playDialogVisible: false,
      searchForm: {
        dateRange: moment().format("YYYY-MM-DD")
      },
      activeTab: '1',
      videoList: [],
      tableHeight: '400',
      tableOptions: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      tableColumns: [
        {
          prop: "carId",
          label: this.$t('common.carId'),
          align: "center",
          // width: "150px"
        },
        {
          prop: "startTime",
          label: this.$t('BatteryStatus.happenTime'),
          align: "center",
          width: "200px"
        },
        {
          prop: "endTime",
          label: this.$t('BatteryStatus.endTime'),
          align: "center",
          width: "200px"
        },
        {
          prop: "size",
          label: this.$t('common.size'),
          align: "center",
          // width: "120px"
        }
      ],
      tableOperates: {
        width: 120,
        fixed: "right",
        list: [
          {
            id: 'view',
            show: true,
            icon: 'el-icon-view',
            label: '',
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleView(row);
            }
          },
          {
            id: 'download',
            show: true,
            icon: 'el-icon-download',
            label: '',
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleDownload(row);
            }
          }
        ]
      },
      // currentPage: 1,
      // pageSize: 10,
      // total: 0,
      videoPlayer: null,
      flvPlayer: null,
      isFlvJsLoaded: false,
      currentPlayingVideo: null,
      isLoading: false
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val && this.currentCarInfo) {
        this.loadVideoList();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  beforeDestroy() {
    this.cleanupVideoPlayer();
    this.cleanupFlvPlayer();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.resetData();
    },
    resetData() {
      this.videoList = [];
      this.activeTab = '1';
      this.searchForm.dateRange = moment().format("YYYY-MM-DD");
      // this.currentPage = 1;
      // this.pageSize = 10;
      // this.total = 0;
    },
    handleSearch() {
      // this.currentPage = 1;
      this.loadVideoList();
    },
    handleTabClick(tab) {
      // this.currentPage = 1;
      this.loadVideoList();
    },
    loadVideoList() {
      if (!this.currentCarInfo) {
        this.$message.warning(this.$t('common.pleaseSelectCar'));
        return;
      }

      const param = {
        carId: this.currentCarInfo.carId,
        channelNo: this.activeTab,
        selectTime: this.searchForm.dateRange,
      };

      this.tableOptions.loading = true;
      this.$store.dispatch('VideoPreview/GET_GETPLAYLIST', param).then(res => {
        this.tableOptions.loading = false;
        if (res && res.data.code === 200) {
          this.videoList = res.data.data || [];
          // this.total = res.data.data.total || 0;
          // this.$refs.page.CommandTotal = this.total;
        } else {
          this.$message.error(res.data.msg || this.$t('common.queryFailed'));
        }
      }).catch(err => {
        this.tableOptions.loading = false;
        console.error('加载历史视频列表失败:', err);
        this.$message.error(this.$t('common.queryFailed'));
      });
    },
    handleView(row) {
      this.currentPlayingVideo = row;
      this.playDialogVisible = true;
      // 等待弹框完全打开后再初始化播放器
      this.$nextTick(() => {
        setTimeout(() => {
          this.playVideo(row);
        }, 100);
      });
    },
    cleanupVideoPlayer() {
      if (this.videoPlayer) {
        try {
          this.videoPlayer.pause();
          this.videoPlayer.dispose();
        } catch (error) {
          console.error('清理视频播放器失败:', error);
        }
        this.videoPlayer = null;
      }
    },
    initVideoPlayer(videoUrl) {
      if (!this.$refs.myVideo) {
        console.log('视频元素未找到，延迟重试...');
        setTimeout(() => this.initVideoPlayer(videoUrl), 100);
        return;
      }
      this.cleanupVideoPlayer();
      try {
        this.videoPlayer = videojs(this.$refs.myVideo, {
          controls: true,
          autoplay: true,
          preload: 'auto',
          fluid: true,
          language: 'zh-CN',
          playbackRates: [0.5, 1, 1.25, 1.5, 2],
          html5: {
            vhs: {
              overrideNative: true
            }
          }
        });
        console.log('视频播放器初始化成功');
        
        // 设置视频源并播放
        this.videoPlayer.src({
          src: videoUrl,
          type: 'video/mp4'
        });
        this.videoPlayer.play().catch(err => {
          console.error('播放视频时的用户交互限制:', err);
        });
        
        this.isLoading = false;
      } catch (error) {
        console.error('播放器初始化失败:', error);
        this.videoPlayer = null;
        this.isLoading = false;
        this.$message.error(this.$t('VideoPreview.playFailed'));
      }
    },
    initFlvPlayer(videoUrl) {
      console.log('开始初始化 FLV 播放器，URL:', videoUrl);
      
      const videoContainer = document.getElementById('history-video-player-container');
      if (!videoContainer) {
        console.error('视频容器未找到，ID: history-video-player-container');
        this.isLoading = false;
        this.$message.error('视频容器未找到，请刷新页面重试');
        return;
      }

      console.log('✓ 视频容器已找到');

      // 动态加载 flv.js
      this.loadFlvJs().then((flvjs) => {
        console.log('flv.js 已加载，版本:', flvjs.version);
        console.log('浏览器支持检查:', flvjs.isSupported());

        // 清空容器并创建 video 元素
        videoContainer.innerHTML = `
          <video 
            id="history-video-element" 
            style="width: 100%; height: 400px; background: #000; object-fit: contain;"
            controls
            preload="auto"
          ></video>
        `;

        this.$nextTick(() => {
          const videoElement = document.getElementById('history-video-element');
          if (!videoElement) {
            console.error('video 元素未找到');
            this.isLoading = false;
            this.$message.error('视频元素创建失败');
            return;
          }

          console.log('✓ video 元素已创建');

          // 检查浏览器是否支持 MediaSource（flv.js 需要）
          if (!flvjs.isSupported()) {
            console.error('浏览器不支持 flv.js');
            videoContainer.innerHTML = `
              <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
                <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
                <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">浏览器不支持</div>
                <p>当前浏览器不支持 FLV 播放</p>
                <p style="color: #909399; font-size: 12px; margin-top: 10px;">请使用 Chrome、Firefox 或 Edge 浏览器</p>
              </div>
            `;
            this.isLoading = false;
            this.$message.error('当前浏览器不支持 FLV 播放，请使用 Chrome、Firefox 或 Edge 浏览器');
            return;
          }

          console.log('✓ 浏览器支持 flv.js');
          console.log('创建 flv.js 播放器实例');

          try {
            // 创建 flv.js 播放器
            this.flvPlayer = flvjs.createPlayer({
              type: 'flv',
              url: videoUrl,
              isLive: false,  // 历史视频不是直播
              hasAudio: false,
              hasVideo: true,
              cors: true
            }, {
              enableWorker: false,
              enableStashBuffer: false,
              stashInitialSize: 128,
              lazyLoad: false,
              seekType: 'range',
              autoCleanupSourceBuffer: true
            });

            console.log('✓ flv.js 播放器配置完成');

            // 附加到 video 元素
            this.flvPlayer.attachMediaElement(videoElement);

            // 加载视频
            this.flvPlayer.load();

            console.log('✓ FLV 视频已加载');

            // 监听元数据加载
            this.flvPlayer.on(flvjs.Events.METADATA_ARRIVED, (metadata) => {
              console.log('✓ FLV 元数据加载完成');
              this.isLoading = false;
            });

            // 监听统计信息
            this.flvPlayer.on(flvjs.Events.STATISTICS_INFO, (stats) => {
              console.log('FLV 统计信息:', stats);
            });

            // 监听错误
            this.flvPlayer.on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
              console.error('✗ FLV 播放错误:', errorType, errorDetail, errorInfo);
              this.isLoading = false;

              let errorMsg = 'FLV 播放失败';
              switch (errorType) {
                case flvjs.ErrorTypes.NETWORK_ERROR:
                  errorMsg = '网络错误，无法连接视频流';
                  break;
                case flvjs.ErrorTypes.MEDIA_ERROR:
                  errorMsg = '媒体错误，视频格式不支持或损坏';
                  break;
                case flvjs.ErrorTypes.OTHER_ERROR:
                  errorMsg = '其他错误: ' + errorDetail;
                  break;
              }
              this.$message.error(errorMsg);
            });

            // 自动播放
            this.flvPlayer.play().then(() => {
              console.log('✓ FLV 视频开始播放');
            }).catch(err => {
              console.error('FLV 自动播放失败:', err);
              // 自动播放失败不显示错误，用户可能手动点击播放
            });

            console.log('✓ FLV 播放器已就绪');
          } catch (error) {
            console.error('创建 flv.js 播放器失败:', error);
            this.isLoading = false;
            this.$message.error('FLV 播放器初始化失败：' + error.message);

            videoContainer.innerHTML = `
              <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
                <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
                <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">播放器初始化失败</div>
                <p>${error.message}</p>
              </div>
            `;
          }
        });
      }).catch(error => {
        console.error('加载 flv.js 失败:', error);
        this.isLoading = false;
        this.$message.error('FLV 播放器加载失败，请刷新页面重试');

        // 显示错误提示
        videoContainer.innerHTML = `
          <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
            <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
            <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">FLV 播放器加载失败</div>
            <div style="font-size: 14px; line-height: 1.8; text-align: center; max-width: 600px;">
              <p style="margin-bottom: 10px;">无法从 CDN 加载 FLV 播放器组件。</p>
              <p style="margin-bottom: 10px; color: #67C23A;"><strong>建议方案：</strong></p>
              <p>请联系后端开发人员将实时视频流转换为 <strong>HLS (m3u8)</strong> 格式</p>
              <p style="color: #909399; font-size: 12px; margin-top: 15px;">或检查网络连接后刷新页面重试</p>
            </div>
          </div>
        `;
      });
    },
    playVideo(row) {
      this.cleanupVideoPlayer();
      this.cleanupFlvPlayer();
      
      // 调用开始播放历史视频接口
      const param = {
        carId: row.carId,
        channelNo: this.activeTab,
        startTime: row.startTime,
        endTime: row.endTime
      };

      this.isLoading = true;
      this.$store.dispatch('VideoPreview/GET_STARTHISTORYVIDEO', param).then(res => {
        if (res && res.data.code === 200) {
          const videoUrl = res.data.data.videoPath;
          console.log('获取到视频URL:', videoUrl);
          
          // 判断视频类型
          const videoType = this.getVideoType(videoUrl);
          console.log('视频类型:', videoType);
          
          // 如果是 FLV 格式，使用 flv.js 播放
          if (videoType === 'video/x-flv') {
            this.initFlvPlayer(videoUrl);
          } else {
            // 其他格式使用 video.js 播放
            this.initVideoPlayer(videoUrl);
          }
        } else {
          this.isLoading = false;
          this.$message.error(res.data.msg || this.$t('VideoPreview.getVideoUrlFailed'));
        }
      }).catch(err => {
        this.isLoading = false;
        console.error('获取历史视频播放地址失败:', err);
        this.$message.error(this.$t('VideoPreview.getVideoUrlFailed'));
      });
    },
    handleDownload(row) {
      const param = {
        carId: row.carId,
        channelNo: this.activeTab,
        selectTime: this.searchForm.dateRange,
      };

      this.$store.dispatch('VideoPreview/GET_DOWNLOADHISTORYVIDEO', param).then(res => {
        if (res && res.data.code === 200) {
          const downloadUrl = res.data.data.downloadUrl;
          if (downloadUrl) {
            // 创建下载链接
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `${row.carId}_${row.startTime.replace(/[:\s]/g, '_')}.mp4`;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success(this.$t('common.downloadSuccess'));
          } else {
            this.$message.error(this.$t('common.downloadFailed'));
          }
        } else {
          this.$message.error(res.data.msg || this.$t('common.downloadFailed'));
        }
      }).catch(err => {
        console.error('下载历史视频失败:', err);
        this.$message.error(this.$t('common.downloadFailed'));
      });
    },
    handlePlayDialogClose() {
      // 调用停止播放历史视频接口
      if (this.currentPlayingVideo) {
        const param = {
          companyId: sessionStorage.getItem("companyId"),
          carId: this.currentPlayingVideo.carId,
          terminalId: this.currentPlayingVideo.terminalId || this.currentPlayingVideo.carId,
          cameraType: this.currentPlayingVideo.cameraType,
          startTime: this.currentPlayingVideo.startTime,
          endTime: this.currentPlayingVideo.endTime
        };

        console.log('停止播放历史视频，参数:', param);
        
        this.$store.dispatch('VideoPreview/GET_STOPHISTORYVIDEO', param).then(res => {
          console.log('停止播放历史视频响应:', res);
          if (res && res.data.code === 200) {
            console.log('✓ 后端停止历史视频播放成功');
          } else {
            console.warn('后端停止历史视频播放返回异常:', res.data.msg);
          }
        }).catch(err => {
          console.error('停止播放历史视频失败:', err);
          // 即使接口调用失败，也要继续执行本地清理
        });
      }

      // 清理播放器
      this.cleanupVideoPlayer();
      this.cleanupFlvPlayer();
      this.currentPlayingVideo = null;
      this.isLoading = false;
    },
    cleanupFlvPlayer() {
      if (this.flvPlayer) {
        try {
          this.flvPlayer.pause();
          this.flvPlayer.unload();
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
        } catch (error) {
          console.error('清理 FLV 播放器失败:', error);
        }
        this.flvPlayer = null;
      }
    },
    loadFlvJs() {
      return new Promise((resolve, reject) => {
        // 检查是否已经加载
        if (window.flvjs) {
          console.log('flv.js 已存在，直接使用');
          this.isFlvJsLoaded = true;
          resolve(window.flvjs);
          return;
        }
        console.log('开始从 CDN 加载 flv.js...');
        // 创建 script 标签
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/flv.js@1.6.2/dist/flv.min.js';
        script.async = true;
        script.onload = () => {
          console.log('✓ flv.js 从 CDN 加载成功', window.flvjs);
          this.isFlvJsLoaded = true;
          resolve(window.flvjs);
        };

        script.onerror = (error) => {
          console.error(' flv.js 加载失败', error);
          reject(new Error('Failed to load flv.js from CDN'));
        };

        document.head.appendChild(script);
      });
    },
    getVideoType(url) {
      if (!url) return '';
      if (url.endsWith('.flv') || url.includes('.flv?')) return 'video/x-flv';
      if (url.endsWith('.m3u8') || url.includes('.m3u8?')) return 'application/x-mpegURL';
      if (url.endsWith('.mp4') || url.includes('.mp4?')) return 'video/mp4';
      return '';
    },
  }
};
</script>

<style lang="less" scoped>
.search-section {
  // margin-bottom: 20px;
  // padding: 15px;
  // background-color: #f5f7fa;
  // border-radius: 4px;
}

.video-player-container {
  width: 100%;
  background-color: #000;
  position: relative;
  
  .video-player-inner {
    width: 100%;
    height: 500px;
    position: relative;
    
    video {
      width: 100%;
      height: 100%;
    }
    
    .loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.8);
      color: #fff;
      z-index: 10;
      
      i {
        font-size: 48px;
        margin-bottom: 20px;
        animation: rotating 1s linear infinite;
      }
      
      span {
        font-size: 16px;
      }
    }
  }
}

.playVideoDialog {
  ::v-deep .el-dialog {
        .el-dialog__header {
          padding: 10px 20px;
          background-color: #409eff;

          .el-dialog__title {
            color: #fff;
          }

          .el-dialog__headerbtn {
            top: 12px;

            .el-dialog__close {
              color: #fff;
              font-size: 20px;
            }
          }
        }

        .el-dialog__body {
          padding: 20px;
        }

        .el-dialog__footer {
          padding: 0 20px 30px;

          .el-button {
            font-size: 14px;
            width: 64px;
            height: 30px;
            padding: 0;
            border-radius: 2px;
          }
        }
      }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/deep/ .history-video-custom {
  .el-dialog__body {
    padding: 20px;
  }
}
</style>
